import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  ChevronUp,
  PlusCircle,
  RotateCcw,
} from "feather-icons-react/build/IconComponents";
import { setToogleHeader } from "../../core/redux/action";
import { useDispatch, useSelector } from "react-redux";
import { Filter, Sliders } from "react-feather";
import Select from "react-select";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import Table from "../../core/pagination/datatable";
// import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../Config";
import ViewAdvanceBooking from "./ViewAdvanceBooking";
import EditAdvanceBooking from "./EditAdvanceBooking";
import SpinLoader from "../loader/SpinLoader";
import CompleteOrder from "./CompleteOrder";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";

const AdvanceBooking = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const MySwal = withReactContent(Swal);
  const navigate = useNavigate();

  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [quotations, setQuotations] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [startDate, setStartDate] = useState(() => {
    const today = new Date();
    const thirtyDaysAgo = new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000);
    return thirtyDaysAgo.toISOString().split("T")[0];
  });
  const [endDate, setEndDate] = useState(
    () => new Date().toISOString().split("T")[0],
  );
  const [quoteNo, setQuoteNo] = useState("");
  const [storeId, setStoreId] = useState("");
  const [viewBooking, setViewBooking] = useState(null);
  const [editBooking, setEditBooking] = useState(null);
  const [completeBooking, setCompleteBooking] = useState(null);
  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setStoreId(userData.StoreId);
    } else {
      navigate("/");
    }
  }, []);

  const fetchQuotations = async () => {
    if (!storeId) return;

    setLoading(true);

    const params = new URLSearchParams();
    params.append("StoreId", storeId);

    if (quoteNo && quoteNo.trim() !== "") {
      params.append("QuoteNo", quoteNo.trim());
    } else {
      params.append("QuoteNo", "null");
    }

    params.append("STdt", startDate || "2025-01-01");
    params.append("enddt", endDate || "2025-12-31");

    const url = `${API_BASE_URL}Billing/getQuotations?${params.toString()}`;

    // console.log("Fetching URL:", url);
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();

      if (
        data.Status &&
        Array.isArray(data.ResultData) &&
        data.ResultData.length > 0
      ) {
        const hasError = data.ResultData[0].ResultMessage?.includes("Error");
        if (hasError) {
          MySwal.fire(
            "Server Error",
            data.ResultData[0].ResultMessage,
            "error",
          );
          setQuotations([]);
        } else {
          setQuotations(data.ResultData);
        }
      } else {
        setQuotations([]);
      }
    } catch (err) {
      console.error("Fetch failed:", err);
      MySwal.fire("Network Error", "Check console for details", "error");
      setQuotations([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQuotations();
  }, [startDate, endDate, quoteNo, storeId]);

  const openViewCanvas = (record) => {
    setViewBooking(record);
  };

  const openCompleteOrder = (record) => {
    setCompleteBooking(record);
  };

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prev) => !prev);
  };
  function downloadBlob(blob, fileName) {
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    link.style.display = "none";

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }
  const exportToPDF = () => {
    if (quotations.length === 0) {
      MySwal.fire("No Data", "Nothing to export", "info");
      return;
    }

    const doc = new jsPDF("portrait", "pt", "a4");

    // Optional header/title
    doc.setFontSize(16);
    doc.text("Advance Bookings ", 40, 30);
    doc.setFontSize(10);
    doc.text(
      `Generated on: ${new Date().toLocaleString()} | Total: ${quotations.length}`,
      40,
      50,
    );

    // Prepare columns (only visible ones – exclude Actions)
    const exportColumns = columns
      .filter((col) => col.title !== "Actions") // skip action column
      .map((col) => col.title);

    // Prepare rows – map data using same render logic where possible
    const exportData = quotations.map((record) => [
      record.QuoteNo || "-",
      record.CustomerName || "Walk-in",
      record.Expected
        ? new Date(record.Expected).toLocaleDateString("en-GB")
        : "-",
      `₹${parseFloat(record.TotalAmount || 0).toFixed(2)}`,
      `₹${parseFloat(record.Advance || 0).toFixed(2)}`,
      (() => {
        const statusVal = record.QuotationStatus;
        return statusVal === 1
          ? "Booked"
          : statusVal === 2
            ? "Ordered"
            : statusVal === 3
              ? "Cancelled"
              : "Pending";
      })(),
    ]);

    // Generate table
    doc.autoTable({
      head: [exportColumns],
      body: exportData,
      startY: 65,
      theme: "grid", // 'striped' | 'grid' | 'plain'
      styles: { fontSize: 9, cellPadding: 6, overflow: "linebreak" },
      headStyles: {
        fillColor: [44, 62, 80], // dark color
        textColor: [255, 255, 255],
        fontStyle: "bold",
      },
      alternateRowStyles: { fillColor: [240, 240, 240] },
      columnStyles: {
        0: { cellWidth: 90 }, // Quote No.
        1: { cellWidth: 140 }, // Customer
        2: { cellWidth: 90 }, // Delivery Date
        3: { cellWidth: 80 }, // Total
        4: { cellWidth: 80 }, // Advance
        5: { cellWidth: 80 }, // Status
      },
      margin: { top: 65, left: 40, right: 40 },
    });

    doc.save(`Advance_Bookings_${new Date().toISOString().split("T")[0]}.pdf`);
  };

  const exportToExcel = () => {
    if (quotations.length === 0) {
      MySwal.fire("No Data", "Nothing to export", "info");
      return;
    }

    // Same columns & data prep as PDF
    const exportColumns = columns
      .filter((col) => col.title !== "Actions")
      .map((col) => col.title);

    const exportData = quotations.map((record) => ({
      "Quote No.": record.QuoteNo || "-",
      Customer: record.CustomerName || "Walk-in",
      "Delivery Date": record.Expected
        ? new Date(record.Expected).toLocaleDateString("en-GB")
        : "-",
      Total: parseFloat(record.TotalAmount || 0),
      Advance: parseFloat(record.Advance || 0),
      Status: (() => {
        const s = record.QuotationStatus;
        return s === 1
          ? "Booked"
          : s === 2
            ? "Ordered"
            : s === 3
              ? "Cancelled"
              : "Pending";
      })(),
    }));

    // Create worksheet
    const ws = XLSX.utils.json_to_sheet(exportData);

    // Optional: auto-size columns (approximate)
    const colWidths = exportColumns.map((_, i) => ({
      wch: [12, 25, 14, 12, 12, 12][i] || 15,
    }));
    ws["!cols"] = colWidths;

    // Workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Bookings");

    // Generate buffer and save
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const dataBlob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
    downloadBlob(
      dataBlob,
      `Advance_Bookings_${new Date().toISOString().split("T")[0]}.xlsx`,
    );
  };

  const oldandlatestvalue = [
    { value: "date", label: "Sort by Date" },
    { value: "newest", label: "Newest" },
    { value: "oldest", label: "Oldest" },
  ];

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderPrinterTooltip = (props) => (
    <Tooltip id="printer-tooltip" {...props}>
      Printer
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="collapse-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const columns = [
    {
      title: "Quote No.",
      dataIndex: "QuoteNo",
      sorter: (a, b) => a.QuoteNo.localeCompare(b.QuoteNo),
    },
    {
      title: "Customer",
      dataIndex: "CustomerName",
      render: (text) => text || "Walk-in",
      sorter: (a, b) =>
        (a.CustomerName || "").localeCompare(b.CustomerName || ""),
    },
    {
      title: "Delivery Date",
      dataIndex: "Expected",
      render: (text) => {
        const date = new Date(text);
        return isNaN(date.getTime()) ? "" : date.toLocaleDateString("en-GB");
      },
      sorter: (a, b) => new Date(a.Expected) - new Date(b.Expected),
    },

    {
      title: "Total",
      dataIndex: "TotalAmount",
      render: (text) => `₹${parseFloat(text || 0).toFixed(2)}`,
    },
    {
      title: "Advance",
      dataIndex: "Advance",
      render: (text) => `₹${parseFloat(text || 0).toFixed(2)}`,
    },
    {
      title: "Status",
      dataIndex: "QuotationStatus",
      render: (value) => {
        const status =
          value === 1
            ? "Booked"
            : value === 2
              ? "Ordered"
              : value === 3
                ? "Cancelled"
                : "Pending";

        const badgeClass =
          status === "Booked"
            ? "bg-success"
            : status === "Ordered"
              ? "bg-primary"
              : status === "Cancelled"
                ? "bg-danger"
                : "unstatus-badge";

        return <span className={`badge badge-sm ${badgeClass}`}>{status}</span>;
      },
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <div>
          <Link to="#" className="dropdown-toggl" data-bs-toggle="dropdown">
            <i className="fa-solid fa-ellipsis-vertical btn border"></i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasViewAdvanceBooking"
              onClick={() => openViewCanvas(record)}
            >
              <i className="fas fa-eye me-2"></i>
              View
            </Link>
            <Link
              className={`dropdown-item ${record.QuotationStatus == 2 || record.QuotationStatus == 3 ? "disabled" : ""}`}
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#editAdvanceBooking"
              onClick={() => {
                setEditBooking(record);
              }}
            >
              <i data-feather="edit" className="feather-edit me-2"></i>Edit
            </Link>

            <Link
              className={`dropdown-item ${record.QuotationStatus == 2 || record.QuotationStatus == 3 ? "disabled" : ""}`}
              to="#"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasCompleteOrder"
              onClick={() => openCompleteOrder(record)}
            >
              <i className="fas fa-check-circle me-2"></i>
              Complete Order
            </Link>

            <Link className="dropdown-item d-none" to="#">
              <i className="fas fa-truck me-2 "></i>Delivery Challan
            </Link>
            <Link className="dropdown-item d-none" to="#">
              <i className="fas fa-clock me-2"></i>Remind User
            </Link>
            <Link
              className="dropdown-item"
              to="#"
              onClick={() => handleCancelOrder(record)}
            >
              <i
                data-feather="trash-2 me-2"
                className="feather-trash-2 me-2"
              ></i>
              cancel
            </Link>
          </div>
        </div>
      ),
    },
  ];

  const handleCancelOrder = async (record) => {
    const quotationId = record?.QuotionId;
    const orgId = JSON.parse(sessionStorage.getItem("userData"))?.OrgId;
    const updatedBy = JSON.parse(sessionStorage.getItem("userData"))?.UserId;

    if (!quotationId || !orgId || !updatedBy) {
      MySwal.fire(
        "Error",
        "Missing required data. Please reload page.",
        "error",
      );
      return;
    }

    const result = await MySwal.fire({
      title: "Cancel Quotation?",
      text: `Are you sure you want to cancel ${record?.QuoteNo}? This action cannot be undone.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, Cancel it!",
      cancelButtonText: "No, Keep it",
    });

    if (result.isConfirmed) {
      try {
        setLoading(true);

        const response = await fetch(`${API_BASE_URL}Billing/cancelQuotation`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            Id: quotationId,
            OrgId: orgId,
            UpdatedBy: updatedBy,
          }),
        });

        const data = await response.json();

        if (data.Status && data.ResultData?.[0]?.Status === 1) {
          MySwal.fire({
            icon: "success",
            title: "Cancelled!",
            text:
              data.ResultData[0].ResultMessage ||
              "Quotation cancelled successfully.",
            timer: 2000,
            showConfirmButton: false,
          });
          fetchQuotations();
        } else {
          MySwal.fire(
            "Failed",
            data.ResultData?.[0]?.ResultMessage || "Something went wrong.",
            "error",
          );
        }
      } catch (err) {
        console.error("Cancel API Error:", err);
        MySwal.fire(
          "Network Error",
          "Unable to cancel quotation. Check connection.",
          "error",
        );
      } finally {
        setLoading(false);
      }
    }
  };

  // const showConfirmationAlert = () => {
  //   MySwal.fire({
  //     title: "Are you sure?",
  //     text: "You won't be able to revert this!",
  //     showCancelButton: true,
  //     confirmButtonColor: "#00ff00",
  //     confirmButtonText: "Yes, delete it!",
  //     cancelButtonColor: "#ff0000",
  //     cancelButtonText: "Cancel",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       // TODO: Call delete API
  //       MySwal.fire({
  //         title: "Deleted!",
  //         text: "Quotation has been deleted.",
  //         icon: "success",
  //         confirmButtonText: "OK",
  //         customClass: { confirmButton: "btn btn-success" },
  //       });
  //     }
  //   });
  // };
// Put this after all states and before return
const filteredQuotations = quotations?.filter((record) => {
  if (!searchText.trim()) return true; // show all when empty

  const search = searchText?.toLowerCase().trim();

  return (
    (record?.QuoteNo || "").toLowerCase().includes(search) ||
    (record?.CustomerName || "").toLowerCase().includes(search) ||
    (record?.QuotationStatus === 1 && "booked".includes(search)) ||
    (record?.QuotationStatus === 2 && "ordered".includes(search)) ||
    (record?.QuotationStatus === 3 && "cancelled".includes(search)) ||
    "pending".includes(search) // for status 0 or others
  );
});
  return (
    <>
      <div>
        <div className="page-wrapper">
          <div className="content">
            <div className="page-header">
              <div className="add-item d-flex">
                <div className="page-title">
                  <h4>Advance Booking</h4>
                  <h6>Manage Your Bookings</h6>
                </div>
              </div>
              <ul className="table-top-head">
                <li>
                  <OverlayTrigger placement="top" overlay={renderTooltip}>
                    <Link onClick={exportToPDF}>
                      <ImageWithBasePath
                        src="assets/img/icons/pdf.svg"
                        alt="img"
                      />
                    </Link>
                  </OverlayTrigger>
                </li>
                <li>
                  <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                    <Link onClick={exportToExcel}>
                      <ImageWithBasePath
                        src="assets/img/icons/excel.svg"
                        alt="img"
                      />
                    </Link>
                  </OverlayTrigger>
                </li>
                <li className="d-none">
                  <OverlayTrigger
                    placement="top"
                    overlay={renderPrinterTooltip}
                  >
                    <Link>
                      <i data-feather="printer" className="feather-printer" />
                    </Link>
                  </OverlayTrigger>
                </li>
                <li>
                  <OverlayTrigger
                    placement="top"
                    overlay={renderRefreshTooltip}
                  >
                    <Link onClick={fetchQuotations}>
                      <RotateCcw />
                    </Link>
                  </OverlayTrigger>
                </li>
                <li>
                  <OverlayTrigger
                    placement="top"
                    overlay={renderCollapseTooltip}
                  >
                    <Link
                      id="collapse-header"
                      className={data ? "active" : ""}
                      onClick={() => dispatch(setToogleHeader(!data))}
                    >
                      <ChevronUp />
                    </Link>
                  </OverlayTrigger>
                </li>
              </ul>
              <div className="page-btn">
                <Link to="/pos/addAdvanceBooking" className="btn btn-added">
                  <PlusCircle className="" />
                </Link>
              </div>
            </div>

            <div className="card table-list-card">
              <div className="card-body">
                <div className="table-top">
                  <div className="search-input">
                  <div className="search-input">
  <input
    type="text"
    placeholder="Search ..."
    className="form-control form-control-sm formsearch"
    value={searchText}
    onChange={(e) => {
      setSearchText(e.target.value);
      // Optional: reset pagination if your Table component has it
    }}
  />
</div>
                  </div>
                  <div className="search-path">
                    <Link
                      className={`btn btn-filter ${
                        isFilterVisible ? "setclose" : ""
                      }`}
                      onClick={toggleFilterVisibility}
                    >
                      <Filter className="filter-icon" />
                      <span>
                        <ImageWithBasePath
                          src="assets/img/icons/closes.svg"
                          alt="img"
                        />
                      </span>
                    </Link>
                  </div>
                  <div className="form-sort d-none">
                    <Sliders className="info-img" />
                    <Select
                      className="select"
                      options={oldandlatestvalue}
                      placeholder="Newest"
                    />
                  </div>
                </div>

                <div
                  className={`card${isFilterVisible ? " visible" : ""}`}
                  id="filter_inputs"
                  style={{ display: isFilterVisible ? "block" : "none" }}
                >
                  <div className="card-body pb-0">
                    <div className="row align-items-end">
                      <div className="col-lg-3 col-sm-6 col-12">
                        <div className="input-blocks">
                          <label className="form-label small">Start Date</label>
                          <input
                            type="date"
                            className="form-control"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-6 col-12">
                        <div className="input-blocks">
                          <label className="form-label small">End Date</label>
                          <input
                            type="date"
                            className="form-control"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-6 col-12 d-none">
                        <div className="input-blocks">
                          <i data-feather="file-text" className="info-img" />
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Quote No. (e.g. EST-1001)"
                            value={quoteNo}
                            onChange={(e) => setQuoteNo(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-6 col-12">
                        <div className="input-blocks">
                          <Link
                            className="btn btn-filters ms-auto"
                            onClick={fetchQuotations}
                          >
                            <i
                              data-feather="search"
                              className="feather-search"
                            />{" "}
                            Search
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="table-responsive">
                  {loading ? (
                    <SpinLoader />
                  ) : (
                    <Table columns={columns} dataSource={filteredQuotations} />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ViewAdvanceBooking booking={viewBooking} />
      <EditAdvanceBooking
        booking={editBooking}
        onClose={() => {
          setEditBooking(null);
          fetchQuotations();
        }}
      />

      <CompleteOrder
        booking={completeBooking}
        onClose={() => {
          setCompleteBooking(null);
          fetchQuotations();
        }}
      />
    </>
  );
};

export default AdvanceBooking;
